import React from 'react';
import { PdfPreview } from 'components/icons';
import styles from './style.module.scss';

export const PreviewLinkPdf = ({ url }) => {
  return (
    <a
      className={styles['preview-icon']}
      href={url}
      target="_blank"
      rel="noopener noreferrer"
    >
      <PdfPreview className={styles['pdf-small']} />
    </a>
  );
};
